<div class="hosting-modal">
    <!-- Loading Spinner Overlay -->
    <div class="loading-overlay" *ngIf="isLoading">
        <div class="loading-container">
            <mat-spinner diameter="60"></mat-spinner>
            <p class="loading-message">{{ loadingMessage }}</p>
        </div>
    </div>

    <div class="modal-header">
        <h2 mat-dialog-title>
            {{ isEditMode ? 'Editar Alojamiento' : 'Crear Nuevo Alojamiento' }}
        </h2>
        <button mat-icon-button (click)="cancel()" class="close-button" [disabled]="isLoading">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content>
        <mat-stepper [linear]="true" [(selectedIndex)]="currentStep" [orientation]="(stepperOrientation | async)!" #stepper>

            <!-- STEP 1: Datos Básicos y Anfitrión -->
            <mat-step [completed]="validateBasicInfo()">
                <ng-template matStepLabel>Información Básica</ng-template>

                <div class="step-content">
                    <h3>Datos del Alojamiento</h3>
                    <div class="form-grid">
                        <mat-form-field class="full-width">
                            <mat-label>Nombre del alojamiento</mat-label>
                            <input matInput [(ngModel)]="basicInfo.name" required />
                            <mat-icon matPrefix>home</mat-icon>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Email</mat-label>
                            <input matInput type="email" [(ngModel)]="basicInfo.email" required />
                            <mat-icon matPrefix>email</mat-icon>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Teléfono</mat-label>
                            <input matInput type="tel" [(ngModel)]="basicInfo.phone" required />
                            <mat-icon matPrefix>phone</mat-icon>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Tipo de alojamiento</mat-label>
                            <mat-select [(ngModel)]="basicInfo.type" required>
                                <mat-option *ngFor="let type of hostingTypes" [value]="type">
                                    {{ type }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Capacidad total</mat-label>
                            <input matInput type="number" [(ngModel)]="basicInfo.capacity" min="1" />
                            <mat-icon matPrefix>group</mat-icon>
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <mat-label>Descripción</mat-label>
                            <textarea matInput [(ngModel)]="basicInfo.description" rows="3"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </mat-step>

            <!-- STEP 2: Ubicación -->
            <mat-step [completed]="validateLocation()">
                <ng-template matStepLabel>Ubicación</ng-template>

                <div class="step-content">
                    <h3>Configuración de Ubicación</h3>
                    <p class="section-description">Selecciona la ubicación exacta de tu alojamiento en el mapa</p>

                    <div class="location-actions">
                        <button mat-raised-button color="accent" (click)="getLocaltionGPS()">
                            <mat-icon>my_location</mat-icon>
                            Usar mi Ubicación GPS
                        </button>
                    </div>

                    <!-- Mapa Principal -->
                    <div class="map-container-modal">
                        <app-mapa-direccion [initialLat]="selectedCoords.lat" [initialLng]="selectedCoords.lng"
                            (coordenadas)="onCoordinatesSelected($event)">
                        </app-mapa-direccion>
                    </div>

                    <!-- Coordenadas Manuales (colapsable) -->
                    <details class="coords-details">
                        <summary>Ingresar coordenadas manualmente</summary>
                        <div class="form-grid" style="margin-top: 1rem;">
                            <mat-form-field>
                                <mat-label>Latitud</mat-label>
                                <input matInput type="number" step="any" [(ngModel)]="locationData.latitude"
                                    placeholder="Ej: 4.7110" />
                                <mat-icon matPrefix>south</mat-icon>
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Longitud</mat-label>
                                <input matInput type="number" step="any" [(ngModel)]="locationData.longitude"
                                    placeholder="Ej: -74.0721" />
                                <mat-icon matPrefix>east</mat-icon>
                            </mat-form-field>

                            <button mat-raised-button color="primary" (click)="applyLatLng()" class="full-width"
                                style="margin-top: 0.5rem;">
                                <mat-icon>place</mat-icon>
                                Aplicar Coordenadas en el Mapa
                            </button>
                        </div>
                    </details>

                    <!-- Información de Dirección -->
                    <div class="form-grid" style="margin-top: 2rem;">
                        <mat-form-field class="full-width">
                            <mat-label>Ubicación seleccionada (coordenadas)</mat-label>
                            <input matInput [(ngModel)]="locationData.coordinates" readonly />
                            <mat-icon matPrefix>place</mat-icon>
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <mat-label>Dirección completa</mat-label>
                            <textarea matInput [(ngModel)]="locationData.full_address" rows="2" required
                                placeholder="Ej: Calle 123 #45-67, Barrio Centro"></textarea>
                            <mat-icon matPrefix>home</mat-icon>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Ciudad</mat-label>
                            <input matInput [(ngModel)]="locationData.city" required placeholder="Ej: Ibagué" />
                            <mat-icon matPrefix>location_city</mat-icon>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>País</mat-label>
                            <input matInput [(ngModel)]="locationData.country" required placeholder="Ej: Colombia" />
                            <mat-icon matPrefix>public</mat-icon>
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <mat-label>Área/Departamento/Estado</mat-label>
                            <input matInput [(ngModel)]="locationData.region" placeholder="Ej: Tolima" />
                            <mat-icon matPrefix>map</mat-icon>
                        </mat-form-field>
                    </div>
                </div>
            </mat-step>

            <!-- STEP 3: Imágenes -->
            <mat-step [completed]="validateImages()">
                <ng-template matStepLabel>Imágenes</ng-template>

                <div class="step-content">
                    <h3>Imágenes del Alojamiento</h3>

                    <div class="upload-area" [class.dragover]="isDragOver" (dragover)="onDragOver($event)"
                        (dragleave)="onDragLeave($event)" (drop)="handleFilesDropped($event)">
                        <div class="upload-content">
                            <mat-icon class="upload-icon">cloud_upload</mat-icon>
                            <p class="upload-text">
                                Arrastra las imágenes aquí o
                                <label for="file-input" class="upload-link">selecciona archivos</label>
                            </p>
                            <input type="file" id="file-input" multiple accept="image/*"
                                (change)="onFilesSelected($event)" style="display: none;">
                            <p class="upload-info">
                                Formatos: JPG, PNG, WebP • Máximo: 5MB por imagen • Límite: 10 imágenes
                            </p>
                        </div>
                    </div>

                    <div class="upload-progress" *ngIf="uploadProgress.visible">
                        <div class="progress-info">
                            <span>Subiendo {{uploadProgress.uploaded}}/{{uploadProgress.total}}</span>
                            <span>{{uploadProgress.percentage}}%</span>
                        </div>
                        <mat-progress-bar mode="determinate" [value]="uploadProgress.percentage"></mat-progress-bar>
                    </div>

                    <div class="images-grid" *ngIf="uploadedImages.length > 0">
                        <div class="image-card" *ngFor="let imagen of uploadedImages; let i = index">
                            <div class="image-preview">
                                <img [src]="imagen.preview" [alt]="'Imagen ' + (i + 1)">

                                <div class="image-overlay" *ngIf="imagen.uploading || imagen.error">
                                    <div class="spinner" *ngIf="imagen.uploading"></div>
                                    <mat-icon *ngIf="imagen.error" class="error-icon">error</mat-icon>
                                </div>

                                <mat-icon *ngIf="imagen.uploaded && !imagen.uploading" class="success-icon">
                                    check_circle
                                </mat-icon>
                            </div>

                            <div class="image-info">
                                <div class="image-name">{{ imagen.file.name }}</div>
                                <div class="image-size">{{ formatFileSize(imagen.file.size) }}</div>
                            </div>

                            <div class="image-actions">
                                <button mat-button [color]="i === 0 ? 'primary' : ''" (click)="markAsMain(i)"
                                    [disabled]="!imagen.uploaded">

                                    <mat-icon>{{ i === 0 ? 'star' : 'star_border' }}</mat-icon>
                                    {{ i === 0 ? 'Principal' : 'Marcar' }}
                                </button>

                                <button mat-icon-button color="warn" (click)="deleteImage(i)"
                                    [disabled]="imagen.uploading">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>

                        </div>
                    </div>

                    <div class="empty-state" *ngIf="hostingImages.length === 0">
                        <mat-icon>image</mat-icon>
                        <p>No has agregado imágenes aún</p>
                        <p class="text-muted">Las imágenes ayudan a mostrar mejor tu alojamiento</p>
                    </div>
                </div>
            </mat-step>

            <!-- STEP 4: Espacios -->
            <mat-step [completed]="validateSpaces()">
                <ng-template matStepLabel>Espacios</ng-template>

                <div class="step-content">
                    <h3>Agregar Espacio</h3>

                    <div class="form-grid">
                        <mat-form-field>
                            <mat-label>Número</mat-label>
                            <input matInput type="number" [(ngModel)]="newSpace.number" min="1" />
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Tipo</mat-label>
                            <input matInput [(ngModel)]="newSpace.type" placeholder="Ej: Suite deluxe" />
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Piso</mat-label>
                            <input matInput type="number" [(ngModel)]="newSpace.floor" min="1" />
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Camas</mat-label>
                            <input matInput type="number" [(ngModel)]="newSpace.beds" min="1" />
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>Capacidad (personas)</mat-label>
                          <input matInput type="number" [(ngModel)]="newSpace.capacity" min="1" />
                          <mat-icon matPrefix>group</mat-icon>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Baños</mat-label>
                            <input matInput type="number" [(ngModel)]="newSpace.bathspaces" min="1" />
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Precio por noche ($)</mat-label>
                            <input matInput type="number" [(ngModel)]="newSpace.price_per_night" min="0" />
                            <mat-icon matPrefix>attach_money</mat-icon>
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <mat-label>Descripción</mat-label>
                            <textarea matInput [(ngModel)]="newSpace.description" rows="3"></textarea>
                        </mat-form-field>
                    </div>

                    <div class="space-images-section">
                        <label>Imágenes de la habitación:</label>
                        <input type="file" multiple accept="image/*" (change)="onHabitacionFilesSelected($event)" />

                        <div *ngIf="spaceImagesLoading" class="loading-indicator">
                            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                            <span>Subiendo imágenes...</span>
                        </div>

                        <div *ngIf="spaceImagesError" class="error-message">
                            <mat-icon>error</mat-icon>
                            {{ spaceImagesError }}
                        </div>

                        <div class="space-images-preview" *ngIf="spaceImagesPreview.length > 0">
                            <div class="space-image-item" *ngFor="let img of spaceImagesPreview">
                                <img [src]="img" alt="Preview" />
                            </div>
                        </div>
                    </div>

                    <button mat-raised-button color="primary" (click)="addSpace()" class="add-space-btn">
                        <mat-icon>add</mat-icon>
                        Añadir Espacio
                    </button>

                    <div class="habitaciones-list" *ngIf="spaces.length > 0">
                        <h4>Espacios agregadas ({{ spaces.length }})</h4>

                        <div class="habitacion-card" *ngFor="let space of spaces; let i = index">
                            <div class="habitacion-header">
                                <h5>#{{ space.number }} - {{ space.type }}</h5>
                                <button mat-icon-button color="warn" (click)="removeSpace(i)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>

                            <div class="habitacion-details">
                                <div class="detail-item">
                                    <mat-icon>layers</mat-icon>
                                    <span>Piso {{ space.floor }}</span>
                                </div>
                                <div class="detail-item">
                                    <mat-icon>hotel</mat-icon>
                                    <span>{{ space.beds }} camas</span>
                                </div>
                                <div class="detail-item">
                                  <mat-icon>group</mat-icon>
                                  <span>{{ space.capacity }} personas</span>
                                </div>
                                <div class="detail-item">
                                    <mat-icon>bathtub</mat-icon>
                                    <span>{{ space.bathspaces }} baños</span>
                                </div>
                                <div class="detail-item price">
                                    <mat-icon>attach_money</mat-icon>
                                    <span>${{ space.price_per_night }}/noche</span>
                                </div>
                            </div>

                            <div class="habitacion-images-mini" *ngIf="space.images && space.images.length">
                                <img *ngFor="let img of space.images" [src]="img" alt="Espacio" />
                            </div>
                        </div>
                    </div>

                    <div class="empty-state" *ngIf="spaces.length === 0">
                        <mat-icon>bed</mat-icon>
                        <p>No has agregado habitaciones aún</p>
                        <p class="text-muted">Agrega al menos una habitación para continuar</p>
                    </div>
                    <div class="space-actions" *ngIf="spaces.length > 0">
                        <button mat-raised-button color="accent" (click)="addAnotherSpace()">
                          <mat-icon>add</mat-icon>
                          añadir otro Espacio
                        </button>
                        <button mat-raised-button color="primary" (click)="finishSpaces()">
                          <mat-icon>check_circle</mat-icon>
                          finalizar Espacios
                        </button>
                    </div>
                </div>
            </mat-step>

            <!-- STEP 5: Servicios y Métodos de Pago -->
            <mat-step [completed]="validatePaymentMethods()">
                <ng-template matStepLabel>Servicios y Pagos</ng-template>

                <div class="step-content">

                    <!-- Servicios Extras -->
                    <h3>Servicios Adicionales (Con Costo)</h3>
                    <div class="servicios-list">
                        <div class="servicio-card">
                            <mat-form-field class="flex-grow">
                                <mat-label>Servicio</mat-label>
                                <input matInput [(ngModel)]="serviceExtraTemp.name" placeholder="Ej: Tour ecológico" />
                            </mat-form-field>

                            <mat-form-field class="cost-field">
                                <mat-label>Costo ($)</mat-label>
                                <input matInput type="number" [(ngModel)]="serviceExtraTemp.cost" min="0" />
                            </mat-form-field>

                            <button mat-raised-button color="primary" (click)="addExtraService()"
                                [disabled]="!serviceExtraTemp.name || !serviceExtraTemp.cost">
                                <mat-icon>add</mat-icon>
                                Agregar
                            </button>
                        </div>

                        <mat-chip-set *ngIf="extraServices.length > 0">
                            <mat-chip *ngFor="let service of extraServices; let i = index"
                                (removed)="removeExtraService(i)">
                                <div class="chip-content">
                                    {{ service.name }} / ${{ service.cost }}
                                </div>
                                <button matChipRemove>
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip>
                        </mat-chip-set>

                        <div class="empty-state" *ngIf="extraServices.length === 0">
                            <mat-icon>check_circle</mat-icon>
                            <p>No has seleccionado servicios extras</p>
                            <p class="text-muted">Agrega al menos un servicio extra para continuar</p>
                        </div>
                    </div>

                    <!-- Servicios Incluidos -->
                    <h3 class="section-title">Servicios Incluidos (Sin Costo)</h3>

                    <div class="payment-selector">
                        <mat-form-field class="flex-grow">
                            <mat-label>Seleccionar servicio incluido</mat-label>
                            <mat-select [(ngModel)]="serviceIncludedTemp">
                                <mat-option *ngFor="let service of avaibleServiceIncluded" [value]="service.name"
                                    [disabled]="includedServices.includes(service)">
                                    <mat-icon>{{ service.icon }}</mat-icon>
                                    {{ service.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <button mat-raised-button color="primary" (click)="addIncludedService(); serviceIncludedTemp=''"
                            [disabled]="!serviceIncludedTemp">
                            <mat-icon>add</mat-icon>
                            Agregar
                        </button>
                    </div>

                    <mat-chip-set *ngIf="includedServices.length > 0">
                        <mat-chip *ngFor="let service of includedServices; let i = index"
                            (removed)="removeIncludedService(i)">
                            <div class="chip-content">
                                <mat-icon>{{ service.icon }}</mat-icon>
                                {{ service.name }}
                            </div>
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip>
                    </mat-chip-set>

                    <div class="empty-state" *ngIf="includedServices.length === 0">
                        <mat-icon>check_circle</mat-icon>
                        <p>No has seleccionado servicios incluídos</p>
                        <p class="text-muted">Agrega al menos un servicio incluído para continuar</p>
                    </div>

                    <!-- Métodos de Pago -->
                    <h3 class="section-title">Métodos de Pago Aceptados</h3>

                    <div class="payment-selector">
                        <mat-form-field class="flex-grow">
                            <mat-label>Seleccionar método de pago</mat-label>
                            <mat-select [(ngModel)]="paymentMethodTemp">
                                <mat-option *ngFor="let method of availablePaymentMethods" [value]="method.name"
                                    [disabled]="paymentMethods.includes(method.name)">
                                    {{ method.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <button mat-raised-button color="primary"
                            (click)="addPaymentMethod(paymentMethodTemp); paymentMethodTemp=''"
                            [disabled]="!paymentMethodTemp">
                            <mat-icon>add</mat-icon>
                            Agregar
                        </button>
                    </div>

                    <mat-chip-set *ngIf="paymentMethods.length > 0">
                        <mat-chip *ngFor="let method of paymentMethods; let i = index"
                            (removed)="removePaymentMethod(i)">
                            {{ method.name }}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip>
                    </mat-chip-set>

                    <div class="empty-state" *ngIf="paymentMethods.length === 0">
                        <mat-icon>payment</mat-icon>
                        <p>No has seleccionado métodos de pago</p>
                        <p class="text-muted">Agrega al menos un método de pago para continuar</p>
                    </div>

                    <!-- Reglas (Opcional) -->
                    <h3 class="section-title">Reglas del Alojamiento (Opcional)</h3>

                    <div class="form-grid" *ngIf="!rule.id">
                        <mat-form-field>
                            <mat-label>Título</mat-label>
                            <input matInput [(ngModel)]="newRule.title" />
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Categoría</mat-label>
                            <input matInput [(ngModel)]="newRule.category" />
                        </mat-form-field>

                        <mat-form-field class="full-width">
                            <mat-label>Descripción</mat-label>
                            <textarea matInput [(ngModel)]="newRule.description" rows="2"></textarea>
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>Penalidad (opcional)</mat-label>
                            <input matInput [(ngModel)]="newRule.penalty" />
                        </mat-form-field>

                        <button mat-raised-button (click)="addRule()"
                            [disabled]="!newRule.title || !newRule.description">
                            <mat-icon>add</mat-icon>
                            Añadir Regla
                        </button>
                    </div>

                    <div class="reglas-list" *ngIf="rule.id">
                        <div class="regla-card">
                            <div class="regla-header">
                                <h5>{{ rule.title }}</h5>
                                <button mat-icon-button color="warn" (click)="removeRule()">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                            <p class="regla-desc">{{ rule.description }}</p>
                            <p class="regla-penalty" *ngIf="rule.penalty">
                                <strong>Penalidad:</strong> {{ rule.penalty }}
                            </p>
                        </div>
                    </div>
                    <div class="empty-state" *ngIf="!rule.id">
                          <mat-icon>description</mat-icon>
                          <p>No has agregado reglas aún</p>
                          <p class="text-muted">Las reglas son opcionales pero ayudan a establecer expectativas claras</p>
                    </div>
                </div>
            </mat-step>

        </mat-stepper>
</mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="cancel()" [disabled]="isLoading">Cancelar</button>
        <button mat-button *ngIf="currentStep > 0" (click)="previousStep()" [disabled]="isLoading">
            <mat-icon>arrow_back</mat-icon>
            Anterior
        </button>
        <button mat-raised-button color="primary" *ngIf="currentStep < 4"
        (click)="nextStep()"
        [disabled]="!validateCurrentStep() || isLoading">
          Siguiente
            <mat-icon>arrow_forward</mat-icon>
        </button>

        <button mat-raised-button color="accent" *ngIf="currentStep === 4" (click)="save()" [disabled]="!isFormValid() || isLoading">
            <mat-icon>save</mat-icon>
            {{ isEditMode ? 'Actualizar' : 'Crear' }} Alojamiento
        </button>
    </mat-dialog-actions>

</div>
